import { Layers3 } from "lucide-react";
import BaseModuleReviewCard from "./BaseModuleReviewCard";

const SelectedModulesReview = ({ modules = [], selectedBaseModules = [] }) => {
  const safeSelectedBaseModules = Array.isArray(selectedBaseModules)
    ? selectedBaseModules
    : [];

  const safeModules = Array.isArray(modules) ? modules : [];

  return (
    <div className="rounded-3xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6 shadow-sm">
      {/* HEADER */}
      <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-2xl flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-500 text-white shadow-lg">
            <Layers3 className="w-5 h-5" />
          </div>

          <div>
            <h4 className="text-lg font-bold text-slate-800 dark:text-white">
              Selected Modules
            </h4>
            <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
              Review selected base modules, child modules, and submodules
            </p>
          </div>
        </div>

        <div className="px-4 py-2 rounded-2xl bg-teal-50 dark:bg-teal-500/10 border border-teal-200 dark:border-teal-500/20 text-teal-700 dark:text-teal-300 text-sm font-semibold">
          {safeSelectedBaseModules.length} Base Modules
        </div>
      </div>

      {/* CONTENT */}
      <div className="space-y-5">
        {safeSelectedBaseModules.length > 0 &&
          safeSelectedBaseModules.map((baseModule) => {
            const originalBase = safeModules.find(
              (m) =>
                String(m.BASEMODULE_ID) === String(baseModule.BASEMODULE_ID),
            );

            if (!originalBase) return null;

            return (
              <BaseModuleReviewCard
                key={baseModule.BASEMODULE_ID}
                baseModule={baseModule}
                originalBase={originalBase}
              />
            );
          })}
      </div>
    </div>
  );
};

export default SelectedModulesReview;
